import { render, staticRenderFns } from "./CorrelateSimilarQuesModal.vue?vue&type=template&id=226aed4c&scoped=true&"
import script from "./CorrelateSimilarQuesModal.vue?vue&type=script&lang=js&"
export * from "./CorrelateSimilarQuesModal.vue?vue&type=script&lang=js&"
import style0 from "./CorrelateSimilarQuesModal.vue?vue&type=style&index=0&id=226aed4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226aed4c",
  null
  
)

export default component.exports